<template>
  <div>

    <validation-observer ref="createOrderValidation">
    
      <b-form
        class="auth-forgot-password-form mt-2"
        @submit.prevent="createOrder"
      >

        <b-row>

          <!-- Field: quantity_products -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Cantidad de seriales"
              label-for="quantity_product"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Cantidad de seriales"
                  rules="required"
                >

                <b-form-input
                  type="number"
                  id="quantity_product"
                  v-model="quantity_products"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

            </b-form-group>

          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            
            <b-form-group
              label="Tipo de Producto"
              label-for="product_type_id"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Tipo de Producto"
                  rules="required"
                >

                <b-form-select
                  id="product_type_id"
                  v-model="product_type_id"
                  :options="productTypeOptions"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

              
            </b-form-group>

          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            
            <b-form-group
              label="Destino"
              label-for="product_type_id"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Destino"
                  rules="required"
                >

                <b-form-select
                  id="product_type_id"
                  v-model="destinationId"
                  :options="destinations"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>

              
            </b-form-group>

          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Solicitud"
              label-for="order_request"
            >
              <b-form-input
                type="text"
                id="order_request"
                v-model="orderRequest"
              />
              <small>Este campo lo llena el cliente, no es obligatorio completarlo</small>
            </b-form-group>

          </b-col>

        </b-row>

        <b-spinner
          v-show="loading"
          variant="primary"
          label="Loading..."
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
           />

        <b-button
          v-show="!loading"
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          Crear pedido
        </b-button>
        <b-button
          variant="outline-secondary"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="$router.push({name: 'order-list'})"
        >
          Cancelar
        </b-button>

      </b-form>
    </validation-observer>


  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormSelect, BSpinner,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { codeMask } from '@/views/forms/form-element/form-input-mask/code'
import { required, email } from '@validations'
import {constants} from "@/helpers/constants"

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormSelect,
    BSpinner,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      host: constants.hostUrl,
      settingData: {},
      quantity_products: null,
      product_type_id: null,
      accessToken: localStorage.getItem('accessToken'),
      productTypeOptions: [
        {
          text: 'Selecciona una opción',
          value: null,
          disabled: true,
        },
        {
          text: 'BOLD NEO',
          value: '1',
        },
        {
          text: 'BOLD PLUS',
          value: '2',
        },
        {
          text: 'BOLD SMART',
          value: '3',
        },
        {
          text: 'BOLD PRO',
          value: '4',
        },
        {
          text: 'SONOQR',
          value: '5',
        },
        {
          text: 'SMART SUNMI',
          value: '6',
        },
        {
          text: 'SMART P2L',
          value: '7',
        },
      ],
      destinations: [
        {
          text: 'Selecciona una opción',
          value: null,
          disabled: true,
        }
      ],
      destinationId: null,
      orderRequest: '',
      loading: false,
    }
  },
  setup(props) {
    const countryOptions = [
      { label: 'Colombia', value: 1 },
    ]

    const serializedOptions = [
      { label: 'Texto', value: 0 },
      { label: 'JSON', value: 1 },
    ]

    return {
      countryOptions,
      serializedOptions,
    }
  },
  created() {
    this.getDestinations()
  },
  methods: {
    getDestinations(){
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.accessToken
      }
      axios.get(this.host + '/api/front-web/destinations', { headers }).then(response => {
        console.log('destinations: ', response)

        let destinations = response.data.data.destinations

        destinations.forEach(destination => {
          this.destinations.push({
            text: destination.name + ' (' + destination.address + ')',
            value: destination.id,
          },)
        })
       
      }).catch( err => {
        console.log(err)
      })

    },
    createOrder() {

      event.preventDefault()
      this.$refs.createOrderValidation.validate().then(success => {
        if (success) {

          this.loading = true

          let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.accessToken
          }
          axios.post(this.host + '/api/front-web/orders', {
            product_type_id: this.product_type_id,
            quantity_products: this.quantity_products,
            order_status_id: 1,
            destination_id: this.destinationId,
            order_request: this.orderRequest,
          }, { headers }).then(response => {
            console.log('orders: ', response)
            this.loading = false
            this.$toast({
                component: ToastificationContentVue,
                position: 'top-right',
                props: {
                  title: `Ok`,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                  text: response.data.message,
                },
              })
              this.$router.push({name: 'order-list'})
          }).catch( err => {
            this.loading = false
            console.log(err)
          })

        }
      })

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
